module.exports = __webpack_public_path__ + "static/media/PolarDrift_Host.603a51fb.png";